/**
 * Central tour configuration constants.
 * Single source of truth for tour names, storage keys, and route mapping.
 */

/** Tour section identifiers */
export const TOUR_NAMES = Object.freeze({
  DASHBOARD: 'dashboard',
  UPLOAD: 'upload',
  TIMELINE: 'timeline',
  INSIGHTS: 'insights',
});

/** localStorage key used to persist "has seen onboarding" flag */
export const TOUR_STORAGE_KEY = 'ht_hasSeenOnboarding';

/** Map route pathnames → tour section name */
export const ROUTE_TO_TOUR = Object.freeze({
  '/dashboard': TOUR_NAMES.DASHBOARD,
  '/upload': TOUR_NAMES.UPLOAD,
  '/timeline': TOUR_NAMES.TIMELINE,
  '/insights': TOUR_NAMES.INSIGHTS,
});

/**
 * Ordered list of tour sections describing the cross-page journey.
 * Used by TourProvider to determine which page comes next.
 */
export const TOUR_ROUTE_ORDER = Object.freeze([
  { tourName: TOUR_NAMES.DASHBOARD, route: '/dashboard' },
  { tourName: TOUR_NAMES.UPLOAD, route: '/upload' },
  { tourName: TOUR_NAMES.TIMELINE, route: '/timeline' },
  { tourName: TOUR_NAMES.INSIGHTS, route: '/insights' },
]);

/**
 * Simulate a backend flag check (e.g. user.hasCompletedOnboarding).
 * Replace with a real API call when available.
 */
export async function checkBackendTourFlag() {
  return new Promise((resolve) => {
    setTimeout(() => {
      const seen = localStorage.getItem(TOUR_STORAGE_KEY) === 'true';
      resolve(seen);
    }, 100);
  });
}
